<template lang="pug">
	.ssml-stylizer-editor.flex-col.space-large
		ListView.full-width(ref="listView", initialView="table", :remoteSorting="true", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", 
			:getItems="(r) => r.Results", :getData="$Data.loadStylizers", valueExpr="Oid", :columns="columns", :filterRow="false", :showColumnHeaders="false", :searchVisible="false", :pageSize="6", :bottomPagerVisible="false")
			template(slot="left-actions")
				DxButton(icon="plus", type="normal", :text="$tCaption('Create')", @click="newStylizer")
			template(v-slot:name-template="{ data }")
				.flex-row.justify.align-center(:class="{ 'disabled-controls': data.__isLoading }")
					.flex-row.space.align-center
						fas(v-if="data.__isLoading", icon="spinner" :spin="true")
						span {{data.Name}}
					.flex-row.space.align-center(v-if="data.Owner && data.Owner.Oid === $auth.companyId()")
						DxButton(icon="edit", stylingMode="text", @click="editStylizer(data)")
						DxButton(icon="trash", type="danger", stylingMode="text", @click="removeStylizer(data)")
		Loader(v-if="isLoading", :fullscreen="true", text="")
		Popup(v-if="editPopupVisible", :popupVisible.sync="editPopupVisible", :width="920", :autosize="true", :title="$tCaption('Stylizer')")
			StylizerDetail(ref="stylizerDetail", :stylizerBO="editingStylizer")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", @click="save", type="success", :disabled="!editingStylizer || !editingStylizer.AiPrompt.Oid || !editingStylizer.Name")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="editPopupVisible = false")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import ListView from 'app-core/ListView.vue';
	import FileUploader from 'app-core/FileUploader.vue';
	import Loader from 'app-core/Loader.vue';
	import StylizerDetail from 'view/stylizer/Detail.vue';
	import Popup from 'app-core/Popup.vue';

	export default {
		translationCategory: 'insertion.SSMLStylizerEditor',
		name: 'reading-rate-editor',
		components: { DxButton, DxTextBox, ListView, FileUploader, Loader, StylizerDetail, Popup },
		props: [],
		data() {
			return {
				columns: [{ dataField: 'Oid', caption: this.$tCaption('Name'), cellTemplate: 'name-template' }],
				isLoading: false,
				editingStylizer: null,
				editPopupVisible: false
			};
		},		
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.ssmlStylizerEditor = this;
		},
		methods: {
			async editStylizer(stylizer) {
				if (stylizer.Oid && !stylizer.AiPrompt) {
					this.isLoading++;
					_.assign(stylizer, await this.$Data.getExternalApi('SsmlStylizer/Get', `id=${stylizer.Oid}`).finally(() => this.isLoading--));
				}
				this.editingStylizer = stylizer;
				this.editPopupVisible = false;
				this.$nextTick(() => this.editPopupVisible = true);
			},
			newStylizer() {
				this.editStylizer({
					Oid: null,
					Name: null,
					Owner: {
						Oid: this.$auth.companyId()
					},
					AiPrompt: {
						Oid: null
					},
					SaveLogs: true
				});
			},
			async save() {
				if (!this.$refs.stylizerDetail.checkRequired()) return;

				this.editPopupVisible = false;

				let isNew = !this.editingStylizer?.Oid;
				if (this.editingStylizer?.Oid) {
					this.$set(this.editingStylizer, '__isLoading', true);
				}
				this.isLoading++;
				await this.$refs.stylizerDetail.save().finally(() => {
					this.isLoading--;
					this.$set(this.editingStylizer, '__isLoading', false);
					if (isNew) {
						if (this.$refs.listView)
							this.$refs.listView.reload();
					}
					this.$emit('change');
				});
			},
			removeStylizer(stylizer) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Do you want to delete the stylizer?'),
					handler: () => {
						this.isLoading++;
						this.$Data.postExternalApi('SsmlStylizer/Delete', [stylizer.Oid]).finally(() => {
							this.isLoading--;
							if (this.$refs.listView)
								this.$refs.listView.reload();
							this.$emit('change');
						});
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	.ssml-stylizer-editor {

	}
</style>
